/*
 * @Description: 全局提示框插件
 * @Date: 2019-09-27 14:53:12
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-09-27 15:26:31
 */
import productCheckResult from './promptBox.vue'
export default {
    install: function(Vue) {
        // Vue.extend() 创建的是一个组件构造器，而不是一个具体的组件实例。所以他不能直接在new Vue中这样使用： new Vue({components: fuck})
        //最终还是要通过Vue.components注册才可以使用的。
        const productCheckResultInstance = Vue.extend(productCheckResult)
        let productCheckResultInit;
        const initInstance = () => {
            // 实例化vue实例
            productCheckResultInit = new productCheckResultInstance();
            // $mount()为手动挂载
            // 如果没有挂载的话，没有关联的 DOM 元素。是获取不到$el
            let productCheckResultEl = productCheckResultInit.$mount().$el;
            // 组件加入文档流
            document.body.appendChild(productCheckResultEl);
        };
        // 全局注册
        Vue.prototype.$Dialog = {
            getProductCheckResult_(options) {
                if (!productCheckResultInit) {
                    initInstance();
                }
                productCheckResultInit.getProductCheckResult(options)
            }
        }
    }
}